import { contactsPageSize } from 'api/contactsPageSize'
import { PaginationWrapper } from 'components/atoms/mTablePagination/PaginationWrapper.tsx'
import { memo } from 'react'
import { useSearchParams } from 'react-router-dom'
import Select from 'react-select'
import { Param, type SkipKey, URLSearchParser } from 'shared/search-adapters'

import css from './Pagination.module.scss'
import { SHOW_ITEMS, showAmountStyles } from './utils'

function Pagination_({
	skipKey = Param.Skip,
	total = 0
}: {
	skipKey?: SkipKey
	total?: number
}) {
	const [params, setParams] = useSearchParams()
	const take = URLSearchParser.PageSize(params)
	const skip = URLSearchParser.Skip(params, skipKey)

	const showPagination = total > take
	const currentPage = Math.floor(skip / take)

	return (
		<footer className={css.footer}>
			{showPagination && (
				<PaginationWrapper
					count={total}
					onPageChange={(_e, page) => {
						setParams(prev => {
							prev.set(skipKey, String(page * take))
							return prev
						})
					}}
					page={currentPage}
					rowsPerPage={take}
					rowsPerPageOptions={[]}
				/>
			)}

			<Select
				className={css.select}
				onChange={item => {
					const nextSize = Number(item.value)

					contactsPageSize.save(nextSize)

					setParams(prev => {
						prev.set(Param.Take, String(nextSize))
						prev.set(Param.Skip, '0')
						prev.set(Param.ModalSkip, '0')
						return prev
					})
				}}
				options={SHOW_ITEMS}
				styles={showAmountStyles}
				value={SHOW_ITEMS.find(el => el.value === take)}
			/>
		</footer>
	)
}

export const SearchPagination = memo(Pagination_)
